import {
  CurrentHairTypeEnum,
  EyeColorEnum,
  HairColorEnum,
  HairTypeEnum,
  PhysicalCharacteristicEnum,
  SkinColorEnum,
} from "./characteristic";
import { LanguageEnum, LanguageProficiencyEnum } from "./language";
import { ClothingSizeEnum, ShoeSizeEnum } from "./measurements";
import { KinshipEnum } from "./responsible";
import { DanceEnum, DriverLicenseEnum, MusicEnum, SportsEnum } from "./skill";
import { FollowerRangeEnum, SocialMediaEnum } from "./social_media";

export enum NationalityEnum {
  BRAZILIAN = "Brasileiro",
  FOREIGN = "Estrangeiro",
}

export type NationalityKey = keyof typeof NationalityEnum;

export enum BooleanValueEnum {
  TRUE = "Sim",
  FALSE = "Não",
}

export enum DeleteTalentRequestOriginEnum {
  ARCHIVED_TALENTS_PAGE = "ARCHIVED_TALENTS_PAGE",
}

export enum GenderIdentityEnum {
  FEMALE = "Feminino",
  MALE = "Masculino",
  UNDEFINED = "Indefinido",
  OTHER = "Outro",
}

export enum DisabilityTypeEnum {
  AUTISM = "Autismo",
  ABSENCE_OR_DEFORMITY = "Ausência ou deformidade",
  WHEELCHAIR_USER = "Cadeirante",
  HEARING_IMPAIRMENT = "Deficiência auditiva",
  VISUAL_IMPAIRMENT = "Deficiência visual",
  AESTHETIC_DEFORMITIES = "Deformidades estéticas",
  DWARFISM = "Nanismo",
  CEREBRAL_PALSY = "Paralisia cerebral",
  DOWN_SYNDROME = "Síndrome de Down",
  OTHERS = "Outros",
}

export type DisabilityTypeKey = keyof typeof DisabilityTypeEnum;

export const talentEnumsMap = {
  NationalityEnum,
  BooleanValueEnum,
  GenderIdentityEnum,
  DisabilityTypeEnum,
  SocialMediaEnum,
  FollowerRangeEnum,
  EyeColorEnum,
  HairColorEnum,
  HairTypeEnum,
  CurrentHairTypeEnum,
  SkinColorEnum,
  PhysicalCharacteristicEnum,
  ShoeSizeEnum,
  ClothingSizeEnum,
  LanguageEnum,
  LanguageProficiencyEnum,
  DriverLicenseEnum,
  SportsEnum,
  MusicEnum,
  DanceEnum,
  KinshipEnum,
};

export type EnumMap = typeof talentEnumsMap;
export type EnumName = keyof EnumMap;
export type EnumKey<T extends EnumName> = keyof EnumMap[T];

export enum TalentStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  STAND_BY = "STAND_BY",
}

export enum ClosingLocationEnum {
  VOGUE = "VOGUE",
  YOUNIQUE = "YOUNIQUE",
  BABY = "BABY",
  EVENTOS = "EVENTOS",
  FRADIQUE = "FRADIQUE",
  REBOUCAS = "REBOUCAS",
  SELETIVA_1 = "SELETIVA_1",
  SELETIVA_2 = "SELETIVA_2",
}

export enum TalentLogSectionEnum {
  ADDRESS = "ADDRESS",
  CONTACT = "CONTACT",
  SOCIAL_MEDIA = "SOCIAL_MEDIA",
  CHARACTERISTICS = "CHARACTERISTICS",
  MEASUREMENTS = "MEASUREMENTS",
  ABILITIES = "ABILITIES",
  RESPONSIBLE = "RESPONSIBLE",
  GENERAL_DATA = "GENERAL_DATA",
  PHOTOGENY = "PHOTOGENY",
}
